var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Login" },
    [
      _c("div", { staticClass: "Login--main" }, [
        _c("img", { attrs: { src: require("../../assets/img/logo.svg") } }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "Login--main-form" },
          [_c(_vm.loginFormView, { tag: "component" })],
          1
        ),
        _vm._v(" "),
        _vm._m(0)
      ]),
      _vm._v(" "),
      _vm.schoolInfo
        ? [
            _c(
              "div",
              {
                staticClass: "Login--image",
                style: {
                  "background-image":
                    _vm.schoolInfo.backgroundImage &&
                    "url(" + _vm.schoolInfo.backgroundImage + ")"
                }
              },
              [
                _c("div", { staticClass: "Login--image-gradient" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "Login--image-content" },
                  [
                    _c("rounded-icon", {
                      staticClass: "kids-hope",
                      attrs: {
                        size: 80,
                        "img-src": _vm.schoolInfo.logo
                          ? _vm.schoolInfo.logo
                          : require("../../assets/img/Default_School_Logo.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("h1", { staticClass: "Login--image-content-goal" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.schoolInfo.schoolName) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.schoolInfo.tagLine
                      ? _c(
                          "h1",
                          { staticClass: "Login--image-content-goal mt-3" },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.schoolInfo.tagLine) +
                                "\n                "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "Login--image-content-address" }, [
                      _c("p", { staticClass: "m-0" }, [
                        _vm._v(_vm._s(_vm.schoolInfo.street))
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "m-0" }, [
                        _vm._v(
                          _vm._s(_vm.schoolInfo.city) +
                            ", " +
                            _vm._s(_vm.schoolInfo.state) +
                            " " +
                            _vm._s(_vm.schoolInfo.zip)
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "m-0" }, [
                        _vm._v(_vm._s(_vm.schoolInfo.country))
                      ])
                    ])
                  ],
                  1
                )
              ]
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "Login--main-footer" }, [
      _vm._v("© Popsicle "),
      _c("sup", [_vm._v("TM")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-731aecce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-731aecce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/no-auth/Login.vue
// module id = null
// module chunks = 